import { Button, Container, Grid, Typography } from "@mui/material";
import {
  getInvestmentPortfolioCancel,
  getInvestmentPortfolioCurrentlyInfo,
  getInvestmentPortfolioCurrentlyList,
  investmentPortfolioCancel,
} from "store/slices/investment/investmentSlice";
import { useEffect, useState } from "react";

import AlertModal from "components/AlertModal";
import { LoadingButton } from "@mui/lab";
import useDispatch from "hooks/useDispatch";

function ConfirmCloseInvestment({ onClose, open, data }) {
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [action, setAction] = useState(null);

  const [investmentPortfolio, setInvestmentPortfolio] = useState();

  const handleCloseInvestment = async () => {
    setSubmitting(true);

    const body = { id: investmentPortfolio?.id };

    await dispatch(
      investmentPortfolioCancel(body),
      "درخواست شما با موفقیت ارسال شد"
    );

    dispatch(getInvestmentPortfolioCurrentlyInfo());
    await dispatch(getInvestmentPortfolioCurrentlyList());

    onClose();

    setSubmitting(false);
  };

  const handleGetInvestmentPortfolioClose = async () => {
    setLoading(true);
    try {
      const { payload } = await dispatch(
        getInvestmentPortfolioCancel(data?.requestId)
      );

      setInvestmentPortfolio(payload?.data?.data);

      setAction({ text: 'آیا مطمئن هستید که می خواهید درخواست خود را لغو کنید؟', succeeded: true })

      setLoading(false);
    } catch (e) {
      setLoading(false);

      await dispatch(getInvestmentPortfolioCurrentlyList());

      setAction({ text: 'اطلاعات بروزرسانی شده است.', succeeded: false })
    }
  };

  useEffect(() => {
    handleGetInvestmentPortfolioClose();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AlertModal open={open} onClose={onClose} variant="error">
      <Container>
        {
          !loading &&
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h4" textAlign="center" mt={2} dir="rtl">
                {action?.text}
              </Typography>

              <Typography></Typography>
            </Grid>

            <Grid item xs={action?.succeeded ? 6 : 12} my={2}>
              <Button color="info" fullWidth onClick={onClose}>
                بازگشت
              </Button>
            </Grid>

            {action?.succeeded &&
              <Grid item xs={6} my={2}>
                <LoadingButton
                  loading={submitting}
                  fullWidth
                  color="error"
                  onClick={handleCloseInvestment}
                  variant="contained"
                >
                  تایید
                </LoadingButton>
              </Grid>}
          </Grid>
        }
      </Container>
    </AlertModal>
  );
}

export default ConfirmCloseInvestment;
